import script from "./SlideCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideCard.vue?vue&type=script&setup=true&lang=js"

import "./SlideCard.vue?vue&type=style&index=0&id=549acc30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-549acc30"]])

export default __exports__